module.exports = __webpack_public_path__ + "assets/img/a7dd-fo.svg";